
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const UserRole = {
  ADMIN: 'ADMIN',
  USER: 'USER'
} as const

export type UserRole = (typeof UserRole)[keyof typeof UserRole]


export const UserEntitlementCode = {
  PRO: 'PRO'
} as const

export type UserEntitlementCode = (typeof UserEntitlementCode)[keyof typeof UserEntitlementCode]


export const CreditLedgerType = {
  MONTHLY_GRANT: 'MONTHLY_GRANT',
  PURCHASE: 'PURCHASE',
  CONSUMPTION: 'CONSUMPTION',
  EXPIRATION: 'EXPIRATION',
  REFUND: 'REFUND',
  CHARGEBACK: 'CHARGEBACK',
  ADJUSTMENT: 'ADJUSTMENT',
  ABSORBED_COST: 'ABSORBED_COST'
} as const

export type CreditLedgerType = (typeof CreditLedgerType)[keyof typeof CreditLedgerType]


export const CreditSource = {
  MONTHLY: 'MONTHLY',
  PURCHASED: 'PURCHASED',
  FREE: 'FREE'
} as const

export type CreditSource = (typeof CreditSource)[keyof typeof CreditSource]


export const CreditPurchaseStatus = {
  PENDING: 'PENDING',
  PAID: 'PAID',
  EXPIRED: 'EXPIRED',
  FAILED: 'FAILED',
  REFUNDED: 'REFUNDED',
  CHARGEBACK: 'CHARGEBACK'
} as const

export type CreditPurchaseStatus = (typeof CreditPurchaseStatus)[keyof typeof CreditPurchaseStatus]


export const AiUsageStatus = {
  COMPLETE: 'COMPLETE',
  PARTIAL: 'PARTIAL',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED'
} as const

export type AiUsageStatus = (typeof AiUsageStatus)[keyof typeof AiUsageStatus]


export const AiReportRunStatus = {
  QUEUED: 'QUEUED',
  RUNNING: 'RUNNING',
  SENT: 'SENT',
  FAILED: 'FAILED',
  BLOCKED_NO_CREDITS: 'BLOCKED_NO_CREDITS',
  SKIPPED_NO_DATA: 'SKIPPED_NO_DATA'
} as const

export type AiReportRunStatus = (typeof AiReportRunStatus)[keyof typeof AiReportRunStatus]


export const AiReportRunType = {
  SCHEDULED: 'SCHEDULED'
} as const

export type AiReportRunType = (typeof AiReportRunType)[keyof typeof AiReportRunType]


export const StripeSubscriptionStatus = {
  INCOMPLETE: 'INCOMPLETE',
  INCOMPLETE_EXPIRED: 'INCOMPLETE_EXPIRED',
  TRIALING: 'TRIALING',
  ACTIVE: 'ACTIVE',
  PAST_DUE: 'PAST_DUE',
  CANCELED: 'CANCELED',
  UNPAID: 'UNPAID',
  PAUSED: 'PAUSED'
} as const

export type StripeSubscriptionStatus = (typeof StripeSubscriptionStatus)[keyof typeof StripeSubscriptionStatus]


export const StripeBillingInterval = {
  MONTHLY: 'MONTHLY',
  ANNUAL: 'ANNUAL'
} as const

export type StripeBillingInterval = (typeof StripeBillingInterval)[keyof typeof StripeBillingInterval]


export const StripeEventStatus = {
  PROCESSING: 'PROCESSING',
  PROCESSED: 'PROCESSED',
  FAILED: 'FAILED'
} as const

export type StripeEventStatus = (typeof StripeEventStatus)[keyof typeof StripeEventStatus]


export const FiscalTransactionOperation = {
  ISSUE_NFSE: 'ISSUE_NFSE',
  CANCEL_NFSE: 'CANCEL_NFSE'
} as const

export type FiscalTransactionOperation = (typeof FiscalTransactionOperation)[keyof typeof FiscalTransactionOperation]


export const FiscalTransactionServiceKind = {
  PRO_SUBSCRIPTION: 'PRO_SUBSCRIPTION',
  AI_CREDITS: 'AI_CREDITS'
} as const

export type FiscalTransactionServiceKind = (typeof FiscalTransactionServiceKind)[keyof typeof FiscalTransactionServiceKind]


export const FiscalTransactionStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  FAILED: 'FAILED',
  COMPLETED: 'COMPLETED',
  CANCELED: 'CANCELED'
} as const

export type FiscalTransactionStatus = (typeof FiscalTransactionStatus)[keyof typeof FiscalTransactionStatus]


export const ContactType = {
  SUPORTE: 'SUPORTE',
  BUG: 'BUG',
  SUGESTAO: 'SUGESTAO',
  OUTRO: 'OUTRO'
} as const

export type ContactType = (typeof ContactType)[keyof typeof ContactType]


export const ChatMessageRole = {
  USER: 'USER',
  ASSISTANT: 'ASSISTANT'
} as const

export type ChatMessageRole = (typeof ChatMessageRole)[keyof typeof ChatMessageRole]


export const ChatMessageStatus = {
  COMPLETE: 'COMPLETE',
  PARTIAL: 'PARTIAL',
  FAILED: 'FAILED'
} as const

export type ChatMessageStatus = (typeof ChatMessageStatus)[keyof typeof ChatMessageStatus]


export const CourseExerciseAttemptStatus = {
  SUBMITTED: 'SUBMITTED',
  PENDING: 'PENDING',
  GRADED: 'GRADED',
  FAILED: 'FAILED'
} as const

export type CourseExerciseAttemptStatus = (typeof CourseExerciseAttemptStatus)[keyof typeof CourseExerciseAttemptStatus]


export const ProspectSentiment = {
  POSITIVO: 'POSITIVO',
  NEUTRO: 'NEUTRO',
  NEGATIVO: 'NEGATIVO',
  AUSENTE: 'AUSENTE'
} as const

export type ProspectSentiment = (typeof ProspectSentiment)[keyof typeof ProspectSentiment]


export const FactPeriodicity = {
  DAILY: 'DAILY',
  MONTHLY: 'MONTHLY',
  FOUR_MONTHLY: 'FOUR_MONTHLY',
  QUARTERLY: 'QUARTERLY',
  ANNUAL: 'ANNUAL'
} as const

export type FactPeriodicity = (typeof FactPeriodicity)[keyof typeof FactPeriodicity]


export const FundTypeOrigin = {
  UNKNOWN: 'UNKNOWN',
  FNET: 'FNET',
  B3_INDEX: 'B3_INDEX',
  TESOURO_TRANSPARENTE: 'TESOURO_TRANSPARENTE'
} as const

export type FundTypeOrigin = (typeof FundTypeOrigin)[keyof typeof FundTypeOrigin]


export const InstrumentClass = {
  FUND: 'FUND',
  FIXED_INCOME: 'FIXED_INCOME',
  INTERNAL: 'INTERNAL'
} as const

export type InstrumentClass = (typeof InstrumentClass)[keyof typeof InstrumentClass]


export const PortfolioAssetCategory = {
  STOCK: 'STOCK',
  FII: 'FII',
  FIAGRO: 'FIAGRO',
  ETF: 'ETF',
  BDR: 'BDR',
  FIXED_INCOME: 'FIXED_INCOME',
  TREASURY: 'TREASURY',
  LOAN: 'LOAN',
  CASH: 'CASH',
  OTHER: 'OTHER'
} as const

export type PortfolioAssetCategory = (typeof PortfolioAssetCategory)[keyof typeof PortfolioAssetCategory]


export const PortfolioImportSource = {
  B3_MOVEMENTS_FILE: 'B3_MOVEMENTS_FILE',
  B3_POSITION_FILE: 'B3_POSITION_FILE',
  B3_SYNC: 'B3_SYNC',
  CSV_FILE: 'CSV_FILE',
  MANUAL: 'MANUAL'
} as const

export type PortfolioImportSource = (typeof PortfolioImportSource)[keyof typeof PortfolioImportSource]


export const PortfolioImportStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  SUCCEEDED: 'SUCCEEDED',
  PARTIALLY_SUCCEEDED: 'PARTIALLY_SUCCEEDED',
  FAILED: 'FAILED',
  CANCELED: 'CANCELED'
} as const

export type PortfolioImportStatus = (typeof PortfolioImportStatus)[keyof typeof PortfolioImportStatus]


export const PortfolioTransactionType = {
  BUY: 'BUY',
  SELL: 'SELL'
} as const

export type PortfolioTransactionType = (typeof PortfolioTransactionType)[keyof typeof PortfolioTransactionType]


export const PortfolioTransactionSource = {
  MANUAL: 'MANUAL',
  B3_MOVEMENTS_IMPORT: 'B3_MOVEMENTS_IMPORT',
  B3_POSITION_IMPORT: 'B3_POSITION_IMPORT',
  B3_SYNC: 'B3_SYNC',
  CSV_IMPORT: 'CSV_IMPORT',
  SYSTEM: 'SYSTEM',
  SPLIT_INFERRED: 'SPLIT_INFERRED'
} as const

export type PortfolioTransactionSource = (typeof PortfolioTransactionSource)[keyof typeof PortfolioTransactionSource]


export const PortfolioImportItemStatus = {
  PENDING: 'PENDING',
  IMPORTED: 'IMPORTED',
  SKIPPED: 'SKIPPED',
  FAILED: 'FAILED'
} as const

export type PortfolioImportItemStatus = (typeof PortfolioImportItemStatus)[keyof typeof PortfolioImportItemStatus]


export const PortfolioImportSessionItemStatus = {
  PENDING: 'PENDING',
  PROCESSED: 'PROCESSED',
  IGNORED: 'IGNORED',
  FAILED: 'FAILED'
} as const

export type PortfolioImportSessionItemStatus = (typeof PortfolioImportSessionItemStatus)[keyof typeof PortfolioImportSessionItemStatus]


export const PortfolioIncomeType = {
  DIVIDEND: 'DIVIDEND',
  JCP: 'JCP',
  AMORTIZATION: 'AMORTIZATION',
  OTHER: 'OTHER'
} as const

export type PortfolioIncomeType = (typeof PortfolioIncomeType)[keyof typeof PortfolioIncomeType]


export const PortfolioMode = {
  B3_IMPORTED: 'B3_IMPORTED',
  MANUAL: 'MANUAL',
  B3_SYNC: 'B3_SYNC'
} as const

export type PortfolioMode = (typeof PortfolioMode)[keyof typeof PortfolioMode]


export const PortfolioVisibility = {
  PRIVATE: 'PRIVATE',
  LINK: 'LINK'
} as const

export type PortfolioVisibility = (typeof PortfolioVisibility)[keyof typeof PortfolioVisibility]


export const PortfolioImportSessionStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
} as const

export type PortfolioImportSessionStatus = (typeof PortfolioImportSessionStatus)[keyof typeof PortfolioImportSessionStatus]


export const PortfolioProcessingStatus = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED'
} as const

export type PortfolioProcessingStatus = (typeof PortfolioProcessingStatus)[keyof typeof PortfolioProcessingStatus]


export const McpGrantStatus = {
  ACTIVE: 'ACTIVE',
  REVOKED: 'REVOKED'
} as const

export type McpGrantStatus = (typeof McpGrantStatus)[keyof typeof McpGrantStatus]
